/**
 * Back to Collections Button
 * Handles the color change when button intersects with .private-section
 */

export function init() {
    const backButton = document.querySelector('.back-to-collections-wrapper');
    const privateSection = document.querySelector('.private-section');
    
    if (!backButton || !privateSection) return;
    
    function updateButtonPosition() {
        const buttonRect = backButton.getBoundingClientRect();
        const privateSectionRect = privateSection.getBoundingClientRect();
        
        // Check if button and private section are intersecting/overlapping
        const isIntersecting = (
            buttonRect.top < privateSectionRect.bottom &&
            buttonRect.bottom > privateSectionRect.top
        );
        
        // Add class when intersecting, remove when not
        if (isIntersecting) {
            backButton.classList.add('stuck-to-section');
        } else {
            backButton.classList.remove('stuck-to-section');
        }
    }
    
    // Update on scroll
    window.addEventListener('scroll', updateButtonPosition);
    
    // Update on resize
    window.addEventListener('resize', updateButtonPosition);
    
    // Initial check
    updateButtonPosition();
}
